import React, { useContext, useRef, useState, useEffect } from "react";
import { useLocation } from "react-router-dom";
import ReactGA from "react-ga4";
import useDraggableScroll from "use-draggable-scroll";
import { Button } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { useDebouncedCallback } from "use-debounce";

import axios from "./axios/index";

import TitleHeader from "./new-components/title/Title";
import HeaderInner from "./Components/HeaderInner";
import HeaderInnerInDining from "./Components/HeaderInnerInDining";
import NewFooter from "./NewFooter";

import RItems from "./Components/Search/RItems";
import RCategories from "./Components/Search/RCategories";
import RResturants from "./Components/Search/RResturants";
import Title from "./Components/Search/Title";

import PharmacyCartPost from "./Components/PharmacyCartPost";
import PharmacySearch from "./Components/Search/PharmacySearch";
import PhCategories from "./Components/Search/PhCategories";

import CarSearch from "./Components/Search/CarSearch";
import EntertainmentSearch from "./Components/Search/EntertainmentSearch";
import SPASearch from "./Components/Search/SPASearch";
import SupermarketCartPost from "./Components/SupermarketCartPost";

import SpaLoader from "./Components/Loaders/SpaLoader";
import { ThemeContext } from "./context/ThemeContext";
import useMixpanel from "./hooks/useMixpanel";
import { Skeleton } from "primereact/skeleton";
import CarRentalPost from "./Components/CarRentalPost";
import MaintenanceSearch from "./Components/Search/MaintenanceSearch";

function SearchPage() {
  const inputRef = useRef(null);
  const ref = useRef(null);

  const { track } = useMixpanel();
  const { t } = useTranslation();
  const location = useLocation();
  const { onMouseDown } = useDraggableScroll(ref);
  const { theme } = useContext(ThemeContext);

  const lang = sessionStorage.getItem("lang");
  const logo = localStorage.getItem("logo");

  const rawPath = location.pathname;
  const room_uuid = rawPath.split("/")[1];

  const params = new URLSearchParams(location.search);

  const rawSearch = location.search.replace("?", "");

  const categoryFromOldUrl =
    rawSearch && !rawSearch.includes("=")
      ? decodeURIComponent(rawSearch).replace(/\+/g, " ")
      : "";

  const initialCategory =
    params.get("search_category") || categoryFromOldUrl || "Food Orders";

  const initialSearch = params.get("search") || "";

  const inDining = location.search.includes("in_dining");

  const [loading, setLoading] = useState(false);
  const [loadingData, setLoadingData] = useState(false);
  const [hasSearched, setHasSearched] = useState(false);

  const [categories, setCategories] = useState([]);
  const [selected, setSelected] = useState(initialCategory);
  const [search, setSearch] = useState(initialSearch);
  const [page, setPage] = useState(1);

  const [pagination, setPagination] = useState(null);
  const [linkPage, setLinkPage] = useState([]);

  const [resItems, setResItems] = useState([]);
  const [resCategories, setResCategories] = useState([]);
  const [resResturans, setResResturans] = useState([]);

  const [phItems, setphItems] = useState([]);
  const [phCategories, setphCategories] = useState([]);
  const [pharmacies, setPharmacies] = useState([]);

  const [supItems, setsupItems] = useState([]);
  const [supCategories, setsupCategories] = useState([]);
  const [suparmacies, setsuparmacies] = useState([]);

  const [fItems, setfItems] = useState([]);
  const [fCategories, setfCategories] = useState([]);
  const [florists, setFlorists] = useState([]);

  const [cars, setCars] = useState([]);
  const [entertainment, setEntertainment] = useState([]);
  const [health, setHealth] = useState([]);
  const [maintenance, setMaintenance] = useState([]);
  const [spa, setSpa] = useState([]);

  const [laundryServices, setLaundryServices] = useState([]);
  const [salonServices, setSalonServices] = useState([]);
  const [housekeepingServices, setHousekeepingServices] = useState([]);
  const [tourDesksCategories, setTourDesksCategories] = useState([]);
  const [inStayRentalItems, setInStayRentalItems] = useState([]);
  const [inStayShopProducts, setInStayShopProducts] = useState([]);

  const hasResults =
    resCategories.length > 0 ||
    resItems.length > 0 ||
    resResturans.length > 0 ||
    phCategories.length > 0 ||
    phItems.length > 0 ||
    pharmacies.length > 0 ||
    supCategories.length > 0 ||
    supItems.length > 0 ||
    suparmacies.length > 0 ||
    fCategories.length > 0 ||
    fItems.length > 0 ||
    florists.length > 0 ||
    cars.length > 0 ||
    entertainment.length > 0 ||
    health.length > 0 ||
    maintenance.length > 0 ||
    spa.length > 0 ||
    laundryServices.length > 0 ||
    salonServices.length > 0 ||
    housekeepingServices.length > 0 ||
    tourDesksCategories.length > 0 ||
    inStayRentalItems.length > 0 ||
    inStayShopProducts.length > 0;

  useEffect(() => {
    inputRef.current?.focus();
  }, []);

  const resetResults = () => {
    setPage(1);
    setPagination(null);
    setLinkPage([]);

    setResItems([]);
    setResCategories([]);
    setResResturans([]);

    setphItems([]);
    setphCategories([]);
    setPharmacies([]);

    setsupItems([]);
    setsupCategories([]);
    setsuparmacies([]);

    setfItems([]);
    setfCategories([]);
    setFlorists([]);

    setCars([]);
    setEntertainment([]);
    setHealth([]);
    setMaintenance([]);
    setSpa([]);

    setLaundryServices([]);
    setSalonServices([]);
    setHousekeepingServices([]);
    setTourDesksCategories([]);
    setInStayRentalItems([]);
    setInStayShopProducts([]);
  };

  const scrollToActiveCategory = () => {
    const container = ref.current;
    if (!container) return;

    requestAnimationFrame(() => {
      const activeItem = container.querySelector("li.active");

      if (!activeItem) return;

      activeItem.scrollIntoView({
        behavior: "smooth",
        inline: "center",
        block: "nearest",
      });
    });
  };

  useEffect(() => {
    const getCategories = async () => {
      setLoading(true);

      try {
        const res = await axios.get(`/${room_uuid}/search`, {
          headers: {
            lang,
          },
        });

        const data = res?.data?.data;

        const categoriesList =
          data?.categories
            ?.split(",")
            ?.map((item) => item.trim())
            ?.filter(Boolean) || [];

        setCategories(categoriesList);
      } catch (err) {
        console.log("get categories error", err);
      } finally {
        setLoading(false);
      }
    };

    getCategories();
  }, [room_uuid, lang]);

  useEffect(() => {
    if (categories.length === 0) return;

    const timer = setTimeout(() => {
      scrollToActiveCategory();
      inputRef.current?.focus();
    }, 100);

    return () => clearTimeout(timer);
  }, [selected, categories]);

  const getData = async () => {
    if (!search.trim()) {
      resetResults();
      setHasSearched(false);
      return;
    }

    setLoadingData(true);
    setHasSearched(true);

    try {
      const res = await axios.get(
        `/${room_uuid}/search?search_category=${encodeURIComponent(
          selected
        )}&search=${encodeURIComponent(search)}&page=${page}`,
        {
          headers: {
            lang,
          },
        }
      );

      ReactGA.event({
        category: "Search",
        action: "Fetch_Data",
        value: `Category name: ${selected}, Search words: ${search}`,
      });

      const data = res?.data?.data?.data;

      if (!data) {
        resetResults();
        setHasSearched(true);
        return;
      }

      setLinkPage(data?.pagination_links || []);
      setPagination(data?.pagination || null);

      const totalResults =
        (data?.rItems?.length || 0) +
        (data?.pItems?.length || 0) +
        (data?.sItems?.length || 0) +
        (data?.fItems?.length || 0) +
        (data?.cars?.length || 0) +
        (data?.restaurants?.length || 0) +
        (data?.pharmacies?.length || 0) +
        (data?.spaServices?.length || 0) +
        (data?.laundryServices?.length || 0) +
        (data?.salonServices?.length || 0) +
        (data?.housekeepingServices?.length || 0) +
        (data?.maintenanceCategories?.length || 0) +
        (data?.tourDesksCategories?.length || 0) +
        (data?.inStayRentalItems?.length || 0) +
        (data?.inStayShopProducts?.length || 0);

      track.searchUsed({
        search_term: search,
        results_count: totalResults,
      });

      setResCategories(data?.rCategories || []);
      setResResturans(data?.restaurants || []);

      setphCategories(data?.pCategories || []);
      setPharmacies(data?.pharmacies || []);

      setsupCategories(data?.sCategories || []);
      setsuparmacies(data?.supermarkets || []);

      setfCategories(data?.fCategories || []);
      setFlorists(data?.florists || []);

      setEntertainment(data?.entertainmentCategories || []);
      setHealth(data?.healthcareCategories || []);
      setMaintenance(data?.maintenanceCategories || []);
      setSpa(data?.spaServices || []);
      setTourDesksCategories(data?.tourDesksCategories || []);

      if (page > 1) {
        setResItems((prev) => [...prev, ...(data?.rItems || [])]);
        setphItems((prev) => [...prev, ...(data?.pItems || [])]);
        setsupItems((prev) => [...prev, ...(data?.sItems || [])]);
        setfItems((prev) => [...prev, ...(data?.fItems || [])]);
        setCars((prev) => [...prev, ...(data?.cars || [])]);

        setLaundryServices((prev) => [
          ...prev,
          ...(data?.laundryServices || []),
        ]);

        setSalonServices((prev) => [...prev, ...(data?.salonServices || [])]);

        setHousekeepingServices((prev) => [
          ...prev,
          ...(data?.housekeepingServices || []),
        ]);

        setInStayRentalItems((prev) => [
          ...prev,
          ...(data?.inStayRentalItems || []),
        ]);

        setInStayShopProducts((prev) => [
          ...prev,
          ...(data?.inStayShopProducts || []),
        ]);
      } else {
        setResItems(data?.rItems || []);
        setphItems(data?.pItems || []);
        setsupItems(data?.sItems || []);
        setfItems(data?.fItems || []);
        setCars(data?.cars || []);

        setLaundryServices(data?.laundryServices || []);
        setSalonServices(data?.salonServices || []);
        setHousekeepingServices(data?.housekeepingServices || []);
        setInStayRentalItems(data?.inStayRentalItems || []);
        setInStayShopProducts(data?.inStayShopProducts || []);
      }
    } catch (err) {
      console.log("search error", err);
      resetResults();
      setHasSearched(true);
    } finally {
      setLoadingData(false);
    }
  };

  useEffect(() => {
    getData();
  }, [search, selected, page]);

  const handleInputChange = useDebouncedCallback((event) => {
    const value = event.target.value;

    resetResults();
    setSearch(value);

    if (!value.trim()) {
      setHasSearched(false);
    }
  }, 800);

  const handleCategoryClick = (category) => {
    if (selected === category) return;

    resetResults();
    setSelected(category);

    ReactGA.event({
      category: "Click on the category in search page",
      action: "Click",
      value: `Category name: ${category}`,
    });
  };

  const hasMore = Boolean(pagination?.has_more);

  const renderLoadMore = (extraClassName = "mb-4") => {
    if (!hasMore) return null;

    return (
      <div className={`load_more_div ${extraClassName}`}>
        <Button
          disabled={loadingData}
          className="load_more"
          onClick={() => setPage((prev) => prev + 1)}
        >
          {loadingData ? "Loading..." : "Load More"}
        </Button>
      </div>
    );
  };

  const renderLoadMoreSpinner = () => {
    if (!loadingData || page === 1) return null;

    return (
      <div>
        <Skeleton height="4rem" className="mb-2"></Skeleton>
        <Skeleton height="4rem" className="mb-2"></Skeleton>
        <Skeleton height="4rem" className="mb-2"></Skeleton>
      </div>
    );
  };

  return (
    <div className={theme ? "food" : ""}>
      {theme ? (
        <TitleHeader title={"Search"} hideIcon={inDining} />
      ) : inDining ? (
        <HeaderInnerInDining hideIcon={inDining} />
      ) : (
        <HeaderInner logo={logo} />
      )}

      <main className="home-main pad-top-0 search_page">
        <div className="Search-bar less searchPage mt-3">
          <input
            className="form-control"
            ref={inputRef}
            type="search"
            placeholder={t("Search")}
            style={{ backgroundColor: "#fff" }}
            defaultValue={initialSearch}
            onChange={handleInputChange}
          />

          <i className="fa fa-search" aria-hidden="true"></i>
        </div>

        {loading ? (
          <SpaLoader />
        ) : (
          <>
            {!inDining && (
              <ul
                className="inline-list search"
                style={{ padding: "0 10px" }}
                ref={ref}
                onMouseDown={onMouseDown}
              >
                {categories?.map((category) => (
                  <li
                    key={category}
                    className={selected === category ? "active" : ""}
                    onClick={() => handleCategoryClick(category)}
                  >
                    <Button>{t(category)}</Button>
                  </li>
                ))}
              </ul>
            )}

            {loadingData && page === 1 && (
              <div>
                <Skeleton height="4rem" className="mb-2"></Skeleton>
                <Skeleton height="4rem" className="mb-2"></Skeleton>
                <Skeleton height="4rem" className="mb-2"></Skeleton>
              </div>
            )}

            {hasSearched && !loadingData && !hasResults && (
              <div className="text-center my-5">
                <h6 className="mb-0">No data found</h6>
              </div>
            )}

            {(!loadingData || page > 1) && (
              <>
                {resCategories.length > 0 && <Title des="Categories" />}
                <ul className="display-list three-items v2 v3">
                  {resCategories.map((item) => (
                    <RCategories
                      key={item.id || item.uuid || item.name}
                      category={item}
                      room_uuid={room_uuid}
                      url="RestaurantSubMenu"
                      theme={theme}
                    />
                  ))}
                </ul>

                {resItems.length > 0 && <Title des="Items" />}
                {resItems.map((item) => (
                  <div key={item.id || item.uuid}>
                    <RItems
                      item={item}
                      lang={lang}
                      room_uuid={room_uuid}
                      theme={theme}
                    />
                  </div>
                ))}
                {resItems.length > 0 && renderLoadMoreSpinner()}
                {resItems.length > 0 && renderLoadMore()}

                {resResturans.length > 0 && <Title des="Restaurants" />}
                <div>
                  {resResturans.map((item) => (
                    <RResturants
                      key={item.id || item.uuid}
                      restaurant={item}
                      room_uuid={room_uuid}
                      url="RestaurantMenu"
                      theme={theme}
                    />
                  ))}
                </div>

                {phCategories.length > 0 && <Title des="Categories" />}
                <ul className="display-list three-items v2 v3">
                  {phCategories.map((item) => (
                    <PhCategories
                      key={item.id || item.uuid || item.name}
                      category={item}
                      room_uuid={room_uuid}
                      url="PharmacySubMenu"
                      apiID="pharmacy_id"
                      apiUUID="pharmacie_uuid"
                    />
                  ))}
                </ul>

                {phItems.length > 0 && <Title des="Items" />}
                {phItems.map((item) => (
                  <div
                    key={item.id || item.uuid}
                    className="add-post-container add-cart"
                  >
                    <PharmacyCartPost
                      item={item}
                      pharmacyId={item.pharmacy_id}
                      search={false}
                      subTitle={item.pharmacy_name}
                    />
                  </div>
                ))}
                {phItems.length > 0 && renderLoadMoreSpinner()}
                {phItems.length > 0 && renderLoadMore()}

                {pharmacies.length > 0 && <Title des="Pharmacies" />}
                <div>
                  {pharmacies.map((item) => (
                    <PharmacySearch
                      key={item.id || item.uuid}
                      pharmacie={item}
                      room_uuid={room_uuid}
                      url="pharmacy"
                    />
                  ))}
                </div>

                {supCategories.length > 0 && <Title des="Categories" />}
                <ul className="display-list three-items v2 v3">
                  {supCategories.map((item) => (
                    <PhCategories
                      key={item.id || item.uuid || item.name}
                      category={item}
                      room_uuid={room_uuid}
                      url="SupermarketSubMenu"
                      apiID="supermarket_id"
                      apiUUID="supermarket_uuid"
                      type="supermarket"
                    />
                  ))}
                </ul>

                {supItems.length > 0 && <Title des="Items" />}
                {supItems.map((item) => (
                  <div
                    key={item.id || item.uuid}
                    className="add-post-container add-cart supermarket_box"
                  >
                    <SupermarketCartPost
                      item={item}
                      pharmacyId={item.supermarket_id}
                      subTitle={item.supermarket_name}
                      type="supermarket"
                      canOrder={item.can_order}
                    />
                  </div>
                ))}
                {supItems.length > 0 && renderLoadMoreSpinner()}
                {supItems.length > 0 && renderLoadMore()}

                {fCategories.length > 0 && <Title des="Categories" />}
                <ul className="display-list three-items v2 v3">
                  {fCategories.map((item) => (
                    <PhCategories
                      key={item.id || item.uuid || item.name}
                      category={item}
                      room_uuid={room_uuid}
                      url="FlowersSubMenu"
                      apiID="florist_id"
                      apiUUID="florist_uuid"
                    />
                  ))}
                </ul>

                {fItems.length > 0 && <Title des="Items" />}
                {fItems.map((item) => (
                  <div
                    key={item.id || item.uuid}
                    className="add-post-container add-cart"
                  >
                    <PharmacyCartPost
                      item={item}
                      flowerId={item.florist_id}
                      search={false}
                      subTitle={item.florist_name}
                    />
                  </div>
                ))}
                {fItems.length > 0 && renderLoadMoreSpinner()}
                {fItems.length > 0 && renderLoadMore()}

                {florists.length > 0 && <Title des="Florists" />}
                <div>
                  {florists.map((item) => (
                    <PharmacySearch
                      key={item.id || item.uuid}
                      pharmacie={item}
                      room_uuid={room_uuid}
                      url="flower"
                    />
                  ))}
                </div>

                {cars.length > 0 && <Title des="Cars" />}
                <ul className="display-list car-list two-items v2">
                  {cars.map((item) => (
                    <CarRentalPost
                      key={item.id || item.uuid}
                      car={item}
                      room_uuid={room_uuid}
                      company_uuid={item?.company?.uuid}
                    />
                  ))}
                </ul>
                {cars.length > 0 && renderLoadMoreSpinner()}
                {cars.length > 0 && renderLoadMore("mb-5")}

                {spa.length > 0 && <Title des="Spa Wellness" />}
                {spa.map((item) => (
                  <SPASearch key={item.id || item.uuid} item={item} />
                ))}

                {laundryServices.length > 0 && <Title des="Laundry" />}
                {laundryServices.map((item) => (
                  <EntertainmentSearch
                    key={item.item_id}
                    x={item}
                    url="laundry"
                    room_uuid={room_uuid}
                  />
                ))}

                {salonServices.length > 0 && <Title des="Salon At Home" />}
                {salonServices.map((item) => (
                  <EntertainmentSearch
                    key={item.id || item.uuid}
                    x={item}
                    url="salon"
                    room_uuid={room_uuid}
                  />
                ))}

                {housekeepingServices.length > 0 && (
                  <Title des="Housekeeping" />
                )}
                {housekeepingServices.map((item) => (
                  <EntertainmentSearch
                    key={item.id}
                    x={item}
                    url="housekeeping"
                    room_uuid={room_uuid}
                  />
                ))}

                {inStayRentalItems.length > 0 && (
                  <Title des="In Stay Rentals" />
                )}
                {inStayRentalItems.map((item) => (
                  <EntertainmentSearch
                    key={item.id}
                    x={item}
                    url="in-stay-rental/category"
                    room_uuid={room_uuid}
                  />
                ))}

                {inStayShopProducts.length > 0 && <Title des="In Stay Shop" />}
                {inStayShopProducts.map((item) => (
                  <EntertainmentSearch
                    key={item.id}
                    x={item}
                    url="in-stay-shop/items"
                    room_uuid={room_uuid}
                  />
                ))}

                {entertainment.length > 0 && <Title des="Categories" />}
                <div>
                  {entertainment.map((item) => (
                    <EntertainmentSearch
                      key={item.id || item.uuid}
                      x={item}
                      url="EntertainmentDetail"
                      room_uuid={room_uuid}
                    />
                  ))}
                </div>

                {health.length > 0 && <Title des="Categories" />}
                <div>
                  {health.map((item) => (
                    <EntertainmentSearch
                      key={item.id || item.uuid}
                      x={item}
                      url="HealthcareOrder"
                      room_uuid={room_uuid}
                    />
                  ))}
                </div>

                {maintenance.length > 0 && <Title des="Maintenance" />}
                <ul className="display-list three-items v2 v3">
                  {maintenance.map((item) => (
                    <MaintenanceSearch
                      key={item.id || item.uuid}
                      x={item}
                      room_uuid={room_uuid}
                      url="maintenance"
                    />
                  ))}
                </ul>

                {tourDesksCategories.length > 0 && <Title des="Tour Desk" />}
                <div>
                  {tourDesksCategories.map((item) => (
                    <EntertainmentSearch
                      key={item.id}
                      x={item}
                      room_uuid={room_uuid}
                      url="tour-desk/categories"
                    />
                  ))}
                </div>
              </>
            )}
          </>
        )}
      </main>

      {theme && !inDining ? <NewFooter /> : null}
    </div>
  );
}

export default SearchPage;
